import React, { useState } from "react";
import { TitlesTyp } from "../../../../../../components/Typography/Typography";
import {
  AlignmentEnum,
  FontWeightEnum,
} from "../../../../../../types/AppTypes";
import { DoubleStructure } from "../../../../../../components/core/DoubleStructure/DoubleStructure";
import {
  DIMENSIONS_LABEL,
  LEVELS_LABEL,
  SOFT_SKILLS_LABEL,
} from "../../../../../../constants/Dictionary";
import {
  TextSwitch,
  OptionItem,
} from "../../../../../../components/TextSwitch/TextSwitch";
import {
  StyledManagementPage,
  StyledManagementHeader,
} from "../../../../Management.styled";
import { ManageDimensions } from "./ManageDimensions/ManageDimensions";
import { ManageLevels } from "./ManageLevels/ManageLevels";

type ManageSoftSkillsProps = {
  configYear: number;
};

export const ManageSoftSkills = ({ configYear }: ManageSoftSkillsProps) => {
  const enum SoftSkillsPagesEnum {
    DIMENSIONS = "DIMENSIONS",
    LEVELS = "LEVELS",
  }
  const filters = [
    { value: SoftSkillsPagesEnum.DIMENSIONS, label: DIMENSIONS_LABEL },
    { value: SoftSkillsPagesEnum.LEVELS, label: LEVELS_LABEL },
  ];
  const [selectedFilter, setSelectedFilter] = useState<
    OptionItem<SoftSkillsPagesEnum>
  >(filters[0]);
  const [disableFilters, setDisableFilters] = useState(false);

  return (
    <StyledManagementPage>
      <StyledManagementHeader>
        <DoubleStructure verticalAlignment={AlignmentEnum.CENTER}>
          <TitlesTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {SOFT_SKILLS_LABEL}
          </TitlesTyp>
          <TextSwitch
            disabled={disableFilters}
            selectedOption={selectedFilter}
            setSelectedOption={setSelectedFilter}
            options={filters}
          />
        </DoubleStructure>
      </StyledManagementHeader>
      {selectedFilter.value === SoftSkillsPagesEnum.DIMENSIONS && (
        <ManageDimensions
          toggleFilters={setDisableFilters}
          configYear={configYear}
        />
      )}
      {selectedFilter.value === SoftSkillsPagesEnum.LEVELS && (
        <ManageLevels
          toggleFilters={setDisableFilters}
          configYear={configYear}
        />
      )}
    </StyledManagementPage>
  );
};
